import {
  userService,
  type PartnerUserListParams,
} from '@/entities/user/api/user.api';
import { LIST_STALE_TIME } from '@/shared/constants/query';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export const userKeys = {
  all: ['partner-users'] as const,
  list: (params: PartnerUserListParams) =>
    [...userKeys.all, 'list', params] as const,
};

/** 05 업체 목록. page는 0부터. */
export const useUserList = (params: PartnerUserListParams) =>
  useQuery({
    queryKey: userKeys.list(params),
    queryFn: () => userService.list(params),
    placeholderData: keepPreviousData,
    staleTime: LIST_STALE_TIME,
  });
